const API = process.env.REACT_APP_BACKEND_URL;
const COOKIE = '__Host-X-CSRF-Token=';
let initialization;

const readCsrf = () => {
  const entry = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(COOKIE));
  return entry ? decodeURIComponent(entry.slice(COOKIE.length)) : null;
};

export async function authFetch(path, options) {
  if (!readCsrf()) {
    if (!initialization) initialization = fetch(`${API}/api/auth/csrf`, { credentials: 'include' })
      .then((response) => { if (!response.ok) throw new Error('Unable to prepare secure sign-in.'); })
      .finally(() => { initialization = null; });
    await initialization;
  }
  const token = readCsrf();
  if (!token) throw new Error('Secure sign-in cookies are unavailable.');
  return fetch(`${API}${path}`, {
    ...options, credentials: 'include',
    headers: { ...options.headers, 'X-CSRF-Token': token },
  });
}